// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import HelloController from "./hello_controller";
import LineGraphController from "./line_graph_controller.js";
import BarGraphController from "./bar_graph_controller.js";
import DisputesRefreshController from "./disputes_refresh_controller.js";
import ModalController from "./modal_controller.js";

application.register("hello", HelloController);
application.register("line-graph", LineGraphController);
application.register("bar-graph", BarGraphController);
application.register("disputes-refresh", DisputesRefreshController);
application.register("modal", ModalController);
